var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[this.colorClass],style:(_vm.getWidth),on:{"click":_vm.click}},[(_vm.iconClass)?_c('i',{staticClass:"fa",class:_vm.getIconFAClass}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad250622","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/assets/js/professional/containers/Common/ActionButton.vue
// module id = IlC2
// module chunks = 37